// extracted by mini-css-extract-plugin
export default {"Emojify":"bcg_a bih_g"};